<section class="hd-profile-roles-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-profile-roles-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-profile-roles-cheat-sheet-page__controls" aria-label="Profile roles cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-profile-roles-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-profile-roles-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-profile-roles-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }

  <div class="hd-profile-roles-cheat-sheet-page__deck">
    <div class="hd-profile-roles-cheat-sheet-page__grid">
      @for (card of cards(); track card.line) {
        <article class="profile-roles-card" [style.--line-color]="card.color">
          <header class="profile-roles-card__header">
            <div class="profile-roles-card__header-left">
              <p class="profile-roles-card__kicker">{{ cardTitle() }} {{ card.line }}</p>
              <h3 class="profile-roles-card__name">{{ card.name }}</h3>
            </div>
            <div class="profile-roles-card__header-right">
              <span class="profile-roles-card__number">{{ card.line }}</span>
              <span class="profile-roles-card__keyword">{{ card.keyword }}</span>
              <span class="profile-roles-card__keyword2">{{ card.keyword2 }}</span>
            </div>
          </header>
          <div class="profile-roles-card__columns">
            <div class="profile-roles-card__column">
              @for (role of card.externalization; track role.key) {
                <div class="profile-role">
                  <p class="profile-role__title">
                    <b>{{ role.title }}</b>
                    <span class="profile-role__tag">{{ role.tag }}</span>
                  </p>
                  <ul class="profile-role__bullets">
                    @for (bullet of role.bullets; track $index) {
                      <li>{{ bullet }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
            <div class="profile-roles-card__column">
              @for (role of card.internalization; track role.key) {
                <div class="profile-role">
                  <p class="profile-role__title">
                    <b>{{ role.title }}</b>
                    <span class="profile-role__tag">{{ role.tag }}</span>
                  </p>
                  <ul class="profile-role__bullets">
                    @for (bullet of role.bullets; track $index) {
                      <li>{{ bullet }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
          <footer class="profile-roles-card__meta">{{ card.meta }}</footer>
        </article>
      }
    </div>
  </div>
</section>
